import React from 'react';
import i18n from '../../../i18n/i18n';
import { Button, TextField, Grid, IconButton, Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';
import Switch from '@material-ui/core/Switch';

export default class AddInstitutions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            region: null, regions: [],
            title: null,
            aktivan: true,
        }
    }

    componentDidMount() {
        this.getByURL('region/filter_region', 'regions');

        if (this.props.edit === true) {
            this.setState({ region: this.props.data.id_region });
            this.setState({ title: this.props.data.naziv });
            this.setState({ aktivan: this.props.data.aktivan });
        }
    }

    getByURL(url, obj, event, required) {
        event = event || '';
        required = required || '';
        if (event != null) {
            axios.get(`api/${url}`, { params: { [required]: event } })
                .then(res => this.setState({ [obj]: res.data.data }))
                .catch(error => wentWrong('Something went wrong, please try again!'));
        }
    }

    addInstitutionType() {
        if (
            this.state.title &&
            this.state.region
        ) {
            let data = {
                id: this.props.data.id,
                naziv: this.state.title,
                id_region: Number(this.state.region),
                aktivan: this.state.aktivan,
            }

            axios.post('api/institution/create_type', { data: data })
                .then(res => {
                    this.props.handleClose();
                })
                .catch(error => {
                    wentWrong('Something went wrong, please try again!');
                    console.log(`Error: ${error}`);
                })
        }
        else wentWrong('Please enter all required fields!');
    }

    render() {
        return (
            <div style={{ padding: 20 }}>
                <Dialog open={this.props.add}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{this.props.edit ? i18n.t('Edit institution type') : i18n.t('Add institution type')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-layer">
                            <Grid container justify="space-between" alignContent="space-between" >

                                <Grid item xs={6}>
                                    <TextField required
                                        label={i18n.t('Title')}
                                        value={this.state.title}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ width: '256px', marginBottom: '10px' }}
                                        onChange={(e) => { this.setState({ title: e.target.value }); }} >
                                    </TextField>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField required
                                        label={i18n.t('Region')}
                                        select
                                        value={this.state.region}
                                        InputLabelProps={{ shrink: true }}
                                        SelectProps={{ native: true, }}
                                        style={{ width: '256px', marginBottom: '10px' }}
                                        onChange={(e) => { this.setState({ region: e.target.value }); }} >
                                        <option value='' />
                                        {this.state.regions.map((regions) => <option key={regions.id} value={regions.id}>{regions.naziv}</option>)}
                                    </TextField>
                                </Grid>

                                <Grid item container>
                                    <Typography>{i18n.t('Active')}</Typography>
                                    <Switch
                                        checked={this.state.aktivan}
                                        onChange={(e) => { this.setState({ aktivan: !this.state.aktivan }) }}
                                        name="aktivan"
                                        color="primary"
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Button style={{ alignSelf: 'center', backgroundColor: '#58B4E5', color: 'white', marginTop: '20px', marginBottom: '10px' }}
                                        onClick={() => this.addInstitutionType()}
                                        disabled={this.props.layerPosting} >
                                        {this.props.edit ? i18n.t('Save') : i18n.t('Add')}
                                    </Button>
                                </Grid>

                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
};